module.exports = __webpack_public_path__ + "img/logo_en.b2e4b44f.png";